import { render, staticRenderFns } from "./BuyListsConfigDialog.vue?vue&type=template&id=35b92440&scoped=true&"
import script from "./BuyListsConfigDialog.vue?vue&type=script&lang=js&"
export * from "./BuyListsConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b92440",
  null
  
)

export default component.exports